module.exports = __webpack_public_path__ + "static/screen-2@2x-beaab7e78292927ed9e631a8cf0c675b.png";